module.exports = __webpack_public_path__ + "static/FSRIwordmark-w-58cdcd8fb9ff93b73c9990efee3e5364.png";